import { useNavigate } from 'react-router-dom';

const seoArticles = [
  {
    id: 1,
    title: 'Guida Completa: Come Usare Itaobuy Spreadsheet nel 2026',
    excerpt: 'Tutto ciò che devi sapere per iniziare. Dalla ricerca prodotti alle categorie, una guida passo dopo passo per principianti ed esperti.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Open%20laptop%20on%20wooden%20desk%20displaying%20colorful%20spreadsheet%20data%20with%20fashion%20products%2C%20ceramic%20coffee%20cup%20beside%2C%20morning%20sunlight%20through%20window%20with%20potted%20succulent%2C%20productive%20Italian%20home%20office%20aesthetic%2C%20warm%20inviting%20atmosphere&width=800&height=600&seq=seo-card-01&orientation=landscape',
    route: '/articoli/itaobuy-spreadsheet-guida-completa',
    tag: 'Guida',
  },
  {
    id: 2,
    title: 'Confronto Categorie: Quali Prodotti Scegliere su Itaobuy',
    excerpt: 'Un\'analisi approfondita delle categorie più popolari. Scopri quali prodotti offrono il miglior rapporto qualità-prezzo nel 2026.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20of%20fashion%20products%20on%20two%20wooden%20boards%2C%20left%20side%20shoes%20and%20right%20side%20bags%2C%20warm%20natural%20lighting%2C%20organized%20catalog%20layout%2C%20editorial%20product%20comparison%20photography%20with%20rich%20textures&width=800&height=600&seq=seo-card-02&orientation=landscape',
    route: '/articoli/itaobuy-spreadsheet-confronto-prezzi',
    tag: 'Confronto',
  },
  {
    id: 3,
    title: 'Sicurezza e Affidabilità di Itaobuy Spreadsheet',
    excerpt: 'Itaobuy Spreadsheet è sicuro? Analizziamo trasparenza, organizzazione dati e qualità delle informazioni per acquisti protetti.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Shield%20icon%20hologram%20hovering%20over%20shopping%20bags%20and%20credit%20cards%20on%20a%20dark%20desk%2C%20neon%20green%20security%20symbols%2C%20dramatic%20cyberpunk%20lighting%2C%20trust%20and%20safety%20concept%20photography%20with%20high%20contrast%20and%20modern%20aesthetic&width=800&height=600&seq=seo-card-03&orientation=landscape',
    route: '/articoli/itaobuy-spreadsheet-sicurezza-acquisti',
    tag: 'Sicurezza',
  },
  {
    id: 4,
    title: 'Tutte le Categorie: Lista Completa Aggiornata 2026',
    excerpt: 'Panoramica di tutte le 14 categorie con analisi dettagliate. Scopri quale categoria offre i prodotti più interessanti per te.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20product%20category%20icons%20arranged%20in%20a%20grid%20on%20a%20warm%20cork%20board%20with%20string%20connections%2C%20creative%20office%20wall%20organization%2C%20natural%20daylight%2C%20playful%20organized%20aesthetic%2C%20editorial%20photography%20with%20vibrant%20accents%20and%20textures&width=800&height=600&seq=seo-card-04&orientation=landscape',
    route: '/articoli/itaobuy-spreadsheet-categorie-prodotti',
    tag: 'Categorie',
  },
  {
    id: 5,
    title: 'Come Risparmiare con Itaobuy Spreadsheet: Strategie Avanzate',
    excerpt: 'Tecniche e strategie comprovate per massimizzare il risparmio. Consigli pratici da chi usa lo spreadsheet ogni giorno.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Piggy%20bank%20surrounded%20by%20fashion%20items%20and%20price%20tags%20on%20a%20sunlit%20desk%2C%20coins%20scattered%20artistically%2C%20warm%20golden%20hour%20light%2C%20smart%20shopping%20concept%2C%20editorial%20still%20life%20photography%20with%20inviting%20atmosphere&width=800&height=600&seq=seo-card-05&orientation=landscape',
    route: '/articoli/itaobuy-spreadsheet-confronto-prezzi',
    tag: 'Risparmio',
  },
  {
    id: 6,
    title: 'Itaobuy Spreadsheet per Principianti: Da Dove Iniziare',
    excerpt: 'Sei nuovo? Ecco tutto quello che devi sapere per muovere i primi passi. Una guida semplice e diretta per neofiti assoluti.',
    imageUrl: 'https://readdy.ai/api/search-image?query=First%20steps%20concept%20with%20sneakers%20on%20a%20starting%20line%20drawn%20on%20warm%20wooden%20floor%2C%20morning%20light%20creating%20long%20shadows%2C%20beginner%20journey%20theme%2C%20motivational%20editorial%20photography%20with%20clean%20minimal%20composition%20and%20hopeful%20atmosphere&width=800&height=600&seq=seo-card-06&orientation=landscape',
    route: '/articoli/itaobuy-spreadsheet-guida-completa',
    tag: 'Beginner',
  },
  {
    id: 7,
    title: 'I 5 Errori da Evitare su Itaobuy Spreadsheet',
    excerpt: 'Errori comuni che molti utenti commettono e come evitarli. Impara dalle esperienze degli altri per non ripetere gli stessi sbagli.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warning%20signs%20and%20crossed%20out%20shopping%20mistakes%20on%20a%20cork%20board%20with%20red%20string%2C%20problem%20solving%20concept%2C%20warm%20desk%20lamp%20lighting%2C%20editorial%20photography%20with%20dramatic%20shadows%20and%20learning%20theme&width=800&height=600&seq=seo-card-07&orientation=landscape',
    route: '/articoli/itaobuy-spreadsheet-sicurezza-acquisti',
    tag: 'Tips',
  },
  {
    id: 8,
    title: 'Scarpe su Itaobuy: La Categoria più Popolare Analizzata',
    excerpt: 'Perché le scarpe sono la categoria numero uno? Analisi approfondita con dati, statistiche e consigli per scegliere le migliori.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Collection%20of%20diverse%20designer%20sneakers%20displayed%20on%20tiered%20wooden%20shelves%2C%20spot%20lighting%20creating%20dramatic%20shadows%2C%20sneaker%20store%20aesthetic%2C%20organized%20retail%20display%2C%20editorial%20product%20photography%20with%20rich%20depth%20and%20premium%20feel&width=800&height=600&seq=seo-card-08&orientation=landscape',
    route: '/articoli/itaobuy-spreadsheet-categorie-prodotti',
    tag: 'Scarpe',
  },
  {
    id: 9,
    title: 'Abbigliamento e Moda: Il Meglio di Itaobuy Spreadsheet',
    excerpt: 'Dalle felpe ai pantaloni, tutto ciò che devi sapere sulla moda su Itaobuy. Tendenze, consigli stile e prodotti must-have.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fashion%20clothing%20rack%20with%20coordinated%20outfits%20in%20earthy%20tones%20against%20an%20exposed%20brick%20wall%2C%20industrial%20chic%20boutique%20aesthetic%2C%20warm%20ambient%20track%20lighting%2C%20editorial%20fashion%20retail%20photography%20with%20curated%20style%20and%20inviting%20atmosphere&width=800&height=600&seq=seo-card-09&orientation=landscape',
    route: '/articoli/itaobuy-spreadsheet-categorie-prodotti',
    tag: 'Moda',
  },
  {
    id: 10,
    title: 'Accessori Must-Have Scoperti su Itaobuy Spreadsheet',
    excerpt: 'Orologi, borse, cinture e molto altro. Gli accessori più interessanti che abbiamo trovato navigando tra le categorie.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20watches%20and%20leather%20accessories%20artfully%20arranged%20on%20a%20dark%20velvet%20surface%20with%20golden%20accent%20pieces%2C%20dramatic%20spotlighting%2C%20high%20end%20jewelry%20store%20aesthetic%2C%20editorial%20luxury%20photography%20with%20rich%20contrast%20and%20elegant%20reflections&width=800&height=600&seq=seo-card-10&orientation=landscape',
    route: '/articoli/itaobuy-spreadsheet-confronto-prezzi',
    tag: 'Accessori',
  },
  {
    id: 11,
    title: 'Itaobuy Spreadsheet Mobile: Come Usarlo da Smartphone',
    excerpt: 'Guida completa all\'uso mobile. Scopri come navigare lo spreadsheet dal tuo telefono in modo efficiente e senza problemi.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20colorful%20product%20spreadsheet%20interface%20held%20in%20hand%20against%20a%20blurred%20cafe%20background%2C%20mobile%20shopping%20concept%2C%20warm%20ambient%20lighting%2C%20lifestyle%20tech%20photography%20with%20cozy%20Italian%20cafe%20atmosphere%20and%20soft%20bokeh&width=800&height=600&seq=seo-card-11&orientation=landscape',
    route: '/articoli/itaobuy-spreadsheet-guida-completa',
    tag: 'Mobile',
  },
  {
    id: 12,
    title: 'Il Futuro di Itaobuy Spreadsheet: Tendenze e Novità 2026',
    excerpt: 'Cosa ci riserva il futuro? Trend emergenti, nuove categorie in arrivo e tutto quello che possiamo aspettarci nei prossimi mesi.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Crystal%20ball%20on%20a%20desk%20reflecting%20fashion%20items%20and%20spreadsheet%20data%2C%20futuristic%20yet%20warm%20aesthetic%2C%20prediction%20and%20forecasting%20concept%2C%20soft%20magical%20lighting%20with%20bokeh%20effects%2C%20editorial%20conceptual%20photography%20with%20intrigue%20and%20mystery&width=800&height=600&seq=seo-card-12&orientation=landscape',
    route: '/articoli/itaobuy-spreadsheet-sicurezza-acquisti',
    tag: 'Trend',
  },
];

export default function ArticleCards() {
  const navigate = useNavigate();

  return (
    <section id="guide" className="w-full bg-background-100 py-16 md:py-20 px-4 md:px-8">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6 mb-12">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
            Guide SEO
            <br />
            &amp; Articoli
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md leading-relaxed md:pt-3">
            Articoli originali e approfondimenti creati per aiutarti a comprendere al meglio il mondo di Itaobuy Spreadsheet. Contenuti ottimizzati per offrirti informazioni utili e sempre aggiornate.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {seoArticles.map((article, index) => (
            <button
              key={article.id}
              onClick={() => navigate(article.route)}
              className="group rounded-2xl bg-background-50 overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer text-left"
              style={{ animation: `fadeInUp 0.6s ease-out ${index * 0.05}s forwards`, opacity: 0 }}
            >
              <div className="h-40 md:h-44 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[10px] font-medium mb-2 whitespace-nowrap">
                  {article.tag}
                </span>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-1.5 leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:gap-1.5 transition-all whitespace-nowrap">
                  Leggi l'articolo
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}